<mat-card>
	<mat-card-content class="card-content">
		<div *ngIf="isLoading">Loading {{ categoryType }} pay categories…</div>
		<div *ngIf="!isLoading">There are no {{ categoryType }} pay categories available.</div>
	</mat-card-content>
</mat-card>
